import { actionTypes } from './actions';
import moment from 'moment';

const initialState = {
  account: {},
  accessToken: '',
  expiryDate: moment(0).toISOString(),
  idToken: '',
  refreshToken: '',
  tokenType: '',
  username: '',
  isAuthenticated: false,
  error: null,
  loading: false
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.AUTH_GET_REQUEST: {
      return { ...initialState, loading: true, error: null };
    }
    case actionTypes.AUTH_GET_SUCCESS: {
      return { 
        ...action.payload,
        isAuthenticated: true,
        loading: false,
        error: null
      };
    }
    case actionTypes.AUTH_GET_FAILURE: {
      return {
        ...initialState,
        error: action.error,
        isAuthenticated: false,
        loading: false
      };
    }
    case actionTypes.AUTH_LOGOUT: {
      const { username } = state;
      return { ...initialState, username };
    }
    default: {
      return state;
    }
  }
}
